import _ from 'lodash';

import {addQueryToPath} from '../../../libs/shared/helpers/src/browser/urlHelpers';
import {CardGroupModel} from '../../models/api/cardGroupModel';
import {TeamModel} from '../../models/api/teamModel';
import {ResourceMap} from '../../store/appTypes';

/*
 * Constants.
 */

const cardGroupDefaultLimit = 50;

/*
 * Search Card Groups.
 */

export interface SearchCardGroupOptions {
  limit?: number;
  nextToken?: string;
}

export function buildCardGroupSearchUrl(companyUrl: string, query: string, options: SearchCardGroupOptions) {
  return addQueryToPath(
    `${companyUrl}/search_card_groups/${encodeURIComponent(query)}`,
    serializeSearchCardGroupOptions(options),
  );
}

function serializeSearchCardGroupOptions(options: SearchCardGroupOptions) {
  return {
    limit: options.limit || cardGroupDefaultLimit,
    page_token: options.nextToken || undefined,
  };
}

/**
 * Build a list of card groups based on provided groupIds and namespaces.
 * @param groups Map of groupId to groups to filter on.
 * @param requestedGroupIds List of requested groupIds.
 * @param userTeams Teams that the user belongs to.
 * @param userNamespace Namespace of the user.
 * @returns Filtered results.
 */
export function buildGroupsAccessibleByUser(
  groups: ResourceMap<CardGroupModel>,
  requestedGroupIds: ReadonlyArray<number>,
  userTeams: ReadonlyArray<TeamModel>,
  userNamespace: string,
) {
  return _(requestedGroupIds)
    .map((groupId) => groups[groupId])
    .compact()
    .filter((group) => isGroupAccessibleByUser(group, userTeams, userNamespace))
    .compact()
    .value();
}

export function isGroupAccessibleByUser(
  group: CardGroupModel,
  userTeams: ReadonlyArray<TeamModel>,
  userNamespace: string,
) {
  const userNamespaces = [userNamespace, ...userTeams.map((team) => team.namespace), 'global'];
  return userNamespaces.includes(group.namespace);
}
